import { Button, Checkbox, Modal, Tooltip } from "@material-ui/core";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useMemo, useState } from "react";
import { Edit3 } from "react-feather";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { fdelete, fpatch } from "../../../API/callsAPI";
import { renderFieldContent } from "../../Utilities/CustomTableForAllTrackables/CustomTableBodyForAllTrackables";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component";
import useStyles from "./ShotsCustomTable.styles";
import ReferenceFolderIcon from "../../Utilities/Svg/ReferenceFolderIcon";
import { ArrowSquareIn } from "phosphor-react";
import ShotsPageEditShotModal from "../ShotsPageModals/ShotsPageEditShotModal";

const ShotsCustomTable = ({
  shotsList,
  isMultiSelectEnabled,
  selectedShots,
  setSelectedShots,
  shotPageToggler,
  updateRefreshCounter,
  setIsViewModalOpen,
  fetchFile,
  dragScreen,
  handleDragScreen,
  setDragFileEnterModal,
  departmentsList,
  sliderState,
  handleTableScroll,
  tableRef,
  scrollValue,
  currentPage,
  setIsNewPageLoading,
  handlePageChange,
  statusList,
  sequenceId,
  projectId,
  handleSelectOrUnSelectShot,
  allFieldsConfig,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [isDeleteShotModalOpen, setDeleteShotModalOpen] = useState({
    open: false,
    data: null,
  });
  const [isEditShotModalOpen, setEditShotModalOpen] = useState({
    open: false,
    data: null,
  });

  function handledDeleteShotModalOpenState(e, data) {
    e?.stopPropagation();
    setDeleteShotModalOpen({
      open: true,
      data: data,
    });
  }

  function handleEditShotModalState(e, data) {
    e?.stopPropagation();
    setEditShotModalOpen({
      open: true,
      data: data,
    });
  }

  const handleDeleteShot = async () => {
    try {
      await fdelete({
        url: `trackables/shot/${isDeleteShotModalOpen.data?.id}/`,
      });
      updateRefreshCounter();
      setDeleteShotModalOpen({
        open: false,
        data: null,
      });
      setEditShotModalOpen({
        open: false,
        data: null,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const rows = useMemo(
    () =>
      (shotsList?.results ?? []).map((res) => ({
        id: res.id,
        ...res,
      })),
    [shotsList?.results],
  );

  const handleValueChange = async (fieldName, value, id) => {
    try {
      const res = await fpatch({
        url: `trackables/shot/v2/${id}/`,
        data: {
          [fieldName]: value,
        },
      });
      if (res.status === 200 || res.status === 201) {
        updateRefreshCounter();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRowClick = (params, event) => {
    const data = params.row;
    if (event.ctrlKey) {
      window.open(
        `/${projectId}/sequence/${data.parent_sequence.id}/shots/${data.id}/shotversions`,
      );
      sessionStorage.setItem("scrollpos", window.scrollY);
    } else {
      history.push(
        `/${projectId}/sequence/${data.parent_sequence.id}/shots/${data.id}/shotversions`,
      );
      sessionStorage.setItem("scrollpos", window.scrollY);
    }
  };

  const columns = [
    ...(isMultiSelectEnabled
      ? [
          {
            field: "checkbox",
            headerName: "",
            minWidth: 60,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
              const data = params.row;
              return (
                <Checkbox
                  checked={selectedShots?.some((shot) => data.id === shot.id)}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectOrUnSelectShot?.(data, 0, e);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                  style={{
                    padding: "0",
                    minHeight: "0",
                  }}
                />
              );
            },
          },
        ]
      : []),
    ...(allFieldsConfig ?? []).map((field) => ({
      field: field.name,
      headerName: field.label || field.name,
      minWidth: 190,
      flex: 1,
      sortable: true,

      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            minHeight: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {renderFieldContent({
            field,
            props: { data: params.row },
            handleValueChange: (fieldName, value) =>
              handleValueChange(fieldName, value, params.row.id),
            index: 0,
            statusUrl: `trackables/shot/${params.row.id}/`,
            statusList,
            updateRefreshCounter,
          })}
        </div>
      ),
    })),
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 190,
      sortable: false,
      renderCell: (params) => {
        const data = params.row;
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "100%",
            }}
          >
            {data.media_folders?.media_root_id && (
              <Tooltip placement="top" title="Shot Files">
                <Button
                  disabled={data.media_folders?.media_root_id === null}
                  size="small"
                  onClick={(event) => {
                    event.stopPropagation();
                    if (data.media_folders?.media_root_id) {
                      window.open(
                        `/${projectId}/project-media/${data.media_folders?.media_root_id}`,
                      );
                    }
                  }}
                >
                  <ReferenceFolderIcon size={18} />
                </Button>
              </Tooltip>
            )}
            <Button
              size="small"
              onClick={(event) => {
                // opening the modal after the function has fetched file, else previous file loads first
                event.stopPropagation();
                fetchFile(data.file ? data.id : null).then(() =>
                  setIsViewModalOpen(true),
                );
              }}
            >
              View
            </Button>
            <Tooltip placement="top" title="View Tasks">
              <Button
                style={{ minWidth: "25px", padding: "2px" }}
                onClick={(event) => {
                  event.stopPropagation();
                  history.push(
                    `/${projectId}/sequence/${data.parent_sequence.id}/shots/${data.id}/task`,
                  );
                }}
              >
                <ArrowSquareIn size={18} />
              </Button>
            </Tooltip>
            <Tooltip placement="top" title="Edit Shot">
              <Button
                onClick={(e) => {
                  handleEditShotModalState(e, data);
                }}
              >
                <Edit3 size={18} />
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return (
    <Box
      className={classes.assetsTableContainer}
      sx={{
        height:
          shotsList?.count > 50 ? "calc(100vh - 230px)" : "calc(100vh - 200px)",
        width: "100%",
        overflowX: "auto",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        disableSelectionOnClick
        onRowClick={handleRowClick}
        hideFooter
        sx={{
          width: "max-content",
          minWidth: "100%",
          border: "none",
          bgcolor: "transparent",
          "& .MuiDataGrid-root": {
            background: "#1B1D28 !important",
            color: "#606479 !important",
          },
          "& .MuiDataGrid-cell": {
            borderTop: "1px solid #606479 !important",
            alignItems: "center",
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
            backgroundColor: "#1B1D28",
            color: "#f9f9f9",
          },
          "& .MuiDataGrid-main": {
            minWidth: "max-content",
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
          },
          "& .MuiDataGrid-window": {
            overflowX: "auto",
          },
          "& .MuiDataGrid-footerContainer": {
            display: "none",
          },
          //
          "& .MuiDataGrid-container--top [role='row'], & .MuiDataGrid-container--bottom [role='row']":
            {
              backgroundColor: "#1B1D28 !important",
              borderColor: "#606479",
              borderTop: "1px solid #606479",
              padding: "0px",
            },

          "--DataGrid-rowBorderColor": "#606479",
          "& .MuiDataGrid-columnHeaders": {
            color: "#606479",
            fontSize: {
              xs: "8px",
              sm: "10px",
              md: "12px",
              lg: "14px",
              xl: "16px",
            },
          },
        }}
        slots={{
          noRowsOverlay: () => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              No shots found.
            </Box>
          ),
        }}
      />
      <Modal
        className={classes.shotListPageModals}
        open={isEditShotModalOpen.open}
        onClose={() =>
          setEditShotModalOpen({
            open: false,
            data: null,
          })
        }
      >
        <ShotsPageEditShotModal
          parentShot={isEditShotModalOpen.data}
          shotId={isEditShotModalOpen.data?.id}
          dragScreen={dragScreen}
          handleDragScreen={handleDragScreen}
          setDragFileEnterModal={setDragFileEnterModal}
          departments={departmentsList}
          projectId={projectId}
          sequenceId={sequenceId}
          status={statusList}
          handleEditShotModal={() => {
            setEditShotModalOpen({
              open: false,
              data: null,
            });
          }}
          handledDeleteShotModalOpenState={handledDeleteShotModalOpenState}
          updateRefreshCounter={updateRefreshCounter}
          customFields={shotsList?.custom_fields}
        />
      </Modal>

      <Modal
        className={classes.shotListPageModals}
        open={isDeleteShotModalOpen.open}
        onClose={() =>
          setDeleteShotModalOpen({
            open: false,
            data: null,
          })
        }
      >
        <DeleteModal
          type="Shot"
          name={
            isDeleteShotModalOpen.data?.name || isDeleteShotModalOpen.data?.code
          }
          handleCloseDeleteModal={() => {
            setDeleteShotModalOpen({
              open: false,
              data: null,
            });
          }}
          handleDelete={handleDeleteShot}
        />
      </Modal>
    </Box>
  );
};

export default ShotsCustomTable;
